import { render, staticRenderFns } from "./x-slider.vue?vue&type=template&id=957c58a2&scoped=true&"
import script from "./x-slider.vue?vue&type=script&lang=js&"
export * from "./x-slider.vue?vue&type=script&lang=js&"
import style0 from "./x-slider.vue?vue&type=style&index=0&id=957c58a2&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957c58a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('957c58a2', component.options)
    } else {
      api.reload('957c58a2', component.options)
    }
    module.hot.accept("./x-slider.vue?vue&type=template&id=957c58a2&scoped=true&", function () {
      api.rerender('957c58a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-slider.vue"
export default component.exports